export default __webpack_public_path__ + "static/media/explain-user-icon-alt.fdbc2076.svg";